// ------------------------------------------------------
// RefundPolicy.js
// ------------------------------------------------------

import React, { useEffect, useContext } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import { AppContext } from "./AppContext";

import Header from "./Header";
import Footer from "./Footer";

// ---------------------------------------------
// Policy Data Object
// ---------------------------------------------
const policyData = {
    lastUpdated: "03/01/2025",
    businessOwner: "Mr. Anindya Chowdhury",
    contactEmail: "connect@buzztobrand.com",
    website: "https://www.buzztobrand.com",
};

export default function RefundPolicy() {
    const { settings } = useContext(AppContext);
    const brandName = settings?.brandName || "Buzz To Brand";

    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    const formattedLastUpdated = (() => {
        const [day, month, year] = policyData.lastUpdated.split("/");
        const dateObj = new Date(`${year}-${month}-${day}`);
        return dateObj.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    })();

    return (
        <>
            <Helmet>
                <title>Refund Policy | {brandName}</title>
                <meta
                    name="description"
                    content={`Read the Refund Policy of ${brandName}.`}
                />
            </Helmet>

            <Header />

            <main
                className="p-6 lg:p-16 max-w-3xl mx-auto text-gray-800 leading-relaxed text-justify"
                data-aos="fade-up"
            >
                <h1 className="text-4xl font-bold mb-8 text-center">
                    Refund Policy
                </h1>

                <p className="text-sm text-gray-500 italic mb-10 text-center">
                    Last Updated: {formattedLastUpdated}
                </p>

                <section className="mb-10">
                    <p>
                        Refund terms are specific to each client and are governed
                        by the scope and terms set out in the relevant proposal,
                        agreement, or contract, where explicitly specified.
                        Where no such refund terms are expressly stated, this
                        Refund Policy shall apply by default.
                    </p>

                    <p className="mt-4">
                        As a standard approach, once payment is received, work
                        and resource planning begin immediately. As dedicated
                        capacity and time are reserved for your engagement,
                        payments made for consulting and advisory services are
                        non-refundable, unless explicitly agreed otherwise in
                        writing.
                    </p>

                    <p className="mt-4">
                        We remain committed to delivering our best effort and
                        maintaining clarity on deliverables throughout the
                        engagement.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold mb-3">
                        Contact
                    </h2>
                    <p>
                        For any questions regarding this Refund Policy, please
                        contact us at{" "}
                        <a
                            href={`mailto:${policyData.contactEmail}`}
                            className="text-indigo-600 hover:underline"
                        >
                            {policyData.contactEmail}
                        </a>
                        .
                    </p>
                </section>
            </main>

            <Footer />
        </>
    );
}
